import React from 'react';
import { connect } from "react-redux";
import { Link } from 'react-router-dom';
import { Auth, API } from 'aws-amplify';
import { Table, Button, message } from 'antd';
import { setUser } from 'redux/modules/session/actions';

class Dashboard extends React.Component {
  state = {
    users: [],
    loading: false
  };

  componentWillMount() {
    this.fetchGroup();
    this.setState({ loading: true });
    API.get("api", "users").then(
      resp => {
        this.setState({
          users: resp,
          loading: false
        });
      }
    );
  }
  fetchGroup = async() =>  {
    const sess = await Auth.currentSession();
    const groupInfo = sess.accessToken.payload['cognito:groups'];
    if (!groupInfo.includes('admin')) {
      this.props.history.push('/');
    }
  };

  onBulkOrder = (user) => {
    this.props.dispatch(setUser(user));
    this.props.history.push(`/bulk-orders/create?userId=${user.id}`);
  };

  onMapping = (user) => {
    this.props.dispatch(setUser(user));
    this.props.history.push(`/mappings?userId=${user.id}`);
  };

  onRebuildOrder = () => {
    const orderId = prompt('Enter order ID - like fbq:123, etsy order needs db order ID');
    if (orderId) {
      message.info('Rebuilding order');
      API.post('api', 'orders/rebuild', { body: { orderId }}).then(
        () => {
          message.success('Rebuild started');
        },
        err => {
          message.error(err.message);
        }
      )
    }
  };

  render() {
    const { users, loading } = this.state;
    const columns = [
      {
        title: 'Business',
        dataIndex: 'businessName',
      },
      {
        title: 'First name',
        dataIndex: 'firstName'
      },
      {
        title: 'Last Name',
        dataIndex: 'lastName'
      },
      {
        title: 'email',
        dataIndex: 'email'
      },
      {
        title: 'Phone',
        dataIndex: 'phone'
      },
      {
        render: (row) => (
          <div>
            <a type="link" onClick={() => this.onMapping(row)}>Mappings</a>
            {' / '}
            <a type="link" onClick={() => this.onBulkOrder(row)}>Bulk Order</a>
          </div>
        )
      }
    ];

    return (
      <div>
          <h1>Admin Dashboard</h1>
          <Table
            rowKey="id"
            loading={loading}
            dataSource={users}
            columns={columns}
          />
          <h1>Orders</h1>
          <Button type="primary" onClick={this.onRebuildOrder}>Rebuild Order</Button>
      </div>
    )
  }
}

export default connect()(Dashboard);
